import { ref } from "vue";

export function useLoading(initialLoading: boolean = false) {
  const isLoading = ref(initialLoading);

  const disableButton = () => {
    isLoading.value = true;
  };

  const enableButton = () => {
    isLoading.value = false;
  };

  return {
    isLoading,
    disableButton,
    enableButton,
  };
}
